import React, { useEffect, useRef } from 'react'
import { Button, Form, Input, InputRef, Typography } from 'antd'
import { useIntl } from 'react-intl'

import IntlMessages from '../../../../util/IntlMessages'

const { Paragraph, Text, Link } = Typography

export interface IPasswordStepProps {
  email: string
  adpEnabled: boolean
  isBusy: boolean
  onSubmit: (password: string) => void
  onPasswordChanged: () => void
  onChangeEmail: () => void
  onForgotPassword: () => void
  onConnectWithAdp: () => void
}

const PasswordStep = ({ email, adpEnabled, isBusy, onSubmit, onPasswordChanged, onChangeEmail, onForgotPassword, onConnectWithAdp }: IPasswordStepProps): React.ReactElement => {
  const { formatMessage } = useIntl()
  const [form] = Form.useForm()
  const inputRef = useRef<InputRef | null>(null)

  useEffect(() => {
    inputRef.current?.focus()
  }, [])

  return (
    <>
      <div className="signin-account-row">
        <Text strong data-qa="signin-resolved-email">
          {email}
        </Text>
        <Link onClick={onChangeEmail} data-qa="signin-change-email">
          <IntlMessages id="app.change" />
        </Link>
      </div>
      <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between' }}>
        <Paragraph className="connect-with-email">
          <IntlMessages id="app.password" />
        </Paragraph>
        <Link onClick={onForgotPassword} data-qa="signin-forgot-password">
          <IntlMessages id="connect.forgotYourPassword" />
        </Link>
      </div>
      <Form name="connect-with-email" form={form} layout="horizontal" onFinish={(values) => onSubmit(values.password)} onFieldsChange={() => onPasswordChanged()}>
        <Form.Item name="password" style={{ width: '100%' }} rules={[{ required: true }]}>
          <Input.Password
            size="large"
            data-qa="email-login-password"
            ref={inputRef}
            placeholder={formatMessage({ id: 'connect.inputPasswordPlaceholder' })}
            autoComplete="current-password"
          />
        </Form.Item>
        <Form.Item>
          <Button size="large" type="primary" htmlType="submit" disabled={isBusy} loading={isBusy} data-qa="email-login-submit" block>
            <IntlMessages id="app.login" />
          </Button>
        </Form.Item>
        {adpEnabled && (
          <Button size="large" onClick={onConnectWithAdp} disabled={isBusy} data-qa="signin-adp-submit" block>
            <IntlMessages id="createCompany.connectWithADP" />
          </Button>
        )}
      </Form>
    </>
  )
}

export default PasswordStep
